"use strict";
import { RepoContext } from "./context.js";
import { useContext } from "solid-js";
export default function useRepo() {
  const repo = useContext(RepoContext);
  if (!repo) throw new Error("Please wrap me in a <RepoContext value={repo}>");
  return repo;
}
//# sourceMappingURL=useRepo.js.map
